import { http } from '@codium/codium-vue'
import { merge } from 'lodash'
import 'pusher-js'
import Echo from 'laravel-echo'

export default {
  data () {
    return {
      echo: null,
      connectionStatus: null,
      manuallyDisconnected: false
    }
  },

  watch: {
    connectionStatus (value) {
      if ((value === 'disconnected' && !this.manuallyDisconnected) || value === 'unavailable') {
        setTimeout(() => {
          this.echoConnect()
        }, 2000)
      }
    },
  },

  methods: {
    echoConnect () {
      const options = merge({
        encrypted: process.env.VUE_APP_PUSHER_ENCRYPTED,
        broadcaster: 'pusher',
        key: process.env.VUE_APP_PUSHER_KEY,
        authorizer (channel, options) {
          return {
            authorize (socket, callback) {
              http.post('broadcasting/auth', { socket_id: socket, channel_name: channel.name })
                .then((response) => {
                  callback(null, response.data)
                  http.defaults.headers['X-Socket-ID'] = socket
                })
                .catch(callback)
            }
          }
        },
        namespace: 'Carbon.Events',
        cluster: 'ap1'
      }, process.env.VUE_APP_PUSHER_CONFIG)

      this.echo = new Echo(options)

      this.echo.connector.pusher.connection.bind('state_change', (states) => {
        this.connectionStatus = states.current
      })

      this.connectChannels()
    },

    echoDisconnect () {
      if (this.echo) {
        this.echo.disconnect()
        this.manuallyDisconnected = true
      }
    }
  }
}
